import script from "./DashboardView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardView.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardView.vue?vue&type=style&index=0&id=6a743645&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a743645"]])

export default __exports__